export default "__VITE_ASSET__hyH_29X2__"